import { useState, useEffect } from "react";

import { type Place, fetchDetails } from "@xapp/components";

/**
 * Hook to fetch place details from our places API (Places (new) API Wrapper)
 */
export const usePlaceDetails = (placeId: string | null): [Place, boolean, string] => {
    const [placeDetails, setPlaceDetails] = useState<Place | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!placeId) {
            return;
        }

        setLoading(true);
        setError(null);
        fetchDetails(placeId)
            .then((place) => {
                if (place) {
                    setPlaceDetails(place);
                } else {
                    setError("Failed to fetch place details");
                }
            })
            .catch((err) => {
                setError("Failed to fetch place details");
                console.error(err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [placeId]);

    return [placeDetails, loading, error];
};
